import { ResponsiveContainer, BarChart, XAxis, YAxis, Bar } from 'recharts';

import './TopRecyclingRateBlock.scss';

interface TopRecyclingRateBlockProps {
  graphData: any[];
  tableData: any[];
};

const TopRecyclingRateBlock = (props: TopRecyclingRateBlockProps) => {
  const blockNumber = props.tableData ? Math.ceil((props.tableData.length + 1) / 16.5) : 0;
  return (
    <div className='split-container-top-rr'>
      <div className='graph'>
        <ResponsiveContainer width='100%' height={480}>
          <BarChart
            layout='vertical'
            margin={{left: 10, right: 40}}
            height={480}
            data={props.graphData}
          >
            <XAxis type='number' minTickGap={10} domain={[0, 100]} />
            <YAxis type='category' dataKey='name' width={100} />
            <Bar dataKey='value' fill='#b1d8e6' barSize={60} />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className='table' style={{minHeight: blockNumber * 380}}>
        <table>
          <tr>
            <th style={{ width: '40%' }}>Customer Site</th>
            <th style={{ width: '20%' }}>Recycling %</th>
            <th style={{ width: '20%' }}>Recycled, t</th>
            <th style={{ width: '20%' }}>Total, t</th>
          </tr>
          {props.tableData.map((rr, idx) =>
            <tr key={'top-rr-export-' + idx} className={idx < 5 ? 'top-five-rows' : ''}>
              <td style={{ width: '40%' }}>{rr[0]}</td>
              <td style={{ width: '20%' }}>{rr[1]}</td>
              <td style={{ width: '20%' }}>{rr[2]}</td>
              <td style={{ width: '20%' }}>{rr[3]}</td>
            </tr>
          )}
        </table>
      </div>
    </div>
  );
};

export default TopRecyclingRateBlock;